import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
    selector: '[itemDragging]'
})
export class ItemDragging {
    @Input('itemDragging') data: any;

    constructor(private elementRef: ElementRef) { }

    ngOnInit() {
        // Get the current element
        let el = this.elementRef.nativeElement;
        
        // Set the draggable attribute to the element
        el.draggable = 'true';

        // Set up the dragstart event and add the drag-src CSS class 
        // to change the visual appearance. Set the current todo as the data
        // payload by stringifying the object first
        el.addEventListener('dragstart', (e: any) => {
            //  console.log('Start');

         //   el.classList.add('drag-stand')
            
            e.dataTransfer.effectAllowed = 'move';

            var img = new Image();
            img.src = 'assets/images/people-32.png';
            e.dataTransfer.setDragImage(img, 0, 0);
        });

        // Remove the drag-src class
        //el.addEventListener('dragend', (e: any) => {
        //    e.preventDefault();
        //    el.classList.remove('drag-stand');
        //});
    }
}


// WEBPACK FOOTER //
// ./src/app/_directives/item_drag.directive.ts